import api from '../../../services/api';

export async function httpGetRedscoreSummary({ companyId, startDate, endDate, search } = {}) {
  const params = {};
  if (companyId) params.company_id = companyId;
  if (startDate) params.startDate  = startDate;
  if (endDate)   params.endDate    = endDate;
  if (search)    params.search     = search;

  const { data } = await api.get('/v1/redscore/summary', { params });
  return data?.data ?? data ?? {};
}

export async function httpGetRedscoreMovements({ companyId, startDate, endDate, status, type, paymentType, search } = {}) {
  const params = {};
  if (companyId)    params.company_id   = companyId;
  if (startDate)    params.startDate    = startDate;
  if (endDate)      params.endDate      = endDate;
  if (status)       params.status       = status;
  if (type)         params.type         = type;
  if (paymentType)  params.paymentType  = paymentType;
  if (search)       params.search       = search;

  const { data } = await api.get('/v1/redscore/movements', { params });
  return Array.isArray(data) ? data : (data?.data ?? []);
}

export async function httpGetResaleList() {
  const { data } = await api.get('/v1/resale/list', { params: { pageSize: 300 } });
  return data?.list ?? [];
}

export async function httpGetOrderDetails(orderId) {
  const { data } = await api.get(`/v4/order/${orderId}/view`);
  return data ?? {};
}
